export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Headline_Alignment-97601f4ec377bec389757f39bda02bb5.svg";